import { useParams } from 'react-router-dom'

import { FinanceBudgetDetailRevampPageDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import { BudgetDetailDataCollection } from 'modules/finance/components/Budgets/BudgetDetailDataCollection'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const BudgetDetailRevampPage = () => {
  const { budgetId } = useParams()
  const id = Number(budgetId)

  const { data, loading, error } = useQuery(FinanceBudgetDetailRevampPageDocument, {
    variables: {
      budgetId: id,
    },
  })
  const budget = data?.finance?.budget
  const amounts = data?.finance?.budgetAmountsConnection?.nodes[0]

  return (
    <ResponsivePage.Body loading={loading} error={error}>
      {budget && amounts && <BudgetDetailDataCollection budget={budget} amounts={amounts} />}
    </ResponsivePage.Body>
  )
}

export default BudgetDetailRevampPage
